import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import  shopItems from '../../config/shop';
import Coins from './components/Coins'
import Items from './components/Items'
import Sapphires from './components/Sapphires'
import '../../assets/stylesheets/Shop/Shop.scss'
const Shop =({}) => {
    const { t } = useTranslation();
    const selectedTab = useParams().tab || "coins";

    return (
        <div className={'shop'}>
            <div className={`title`}>{t('shop.text')}</div>
             <div className={'tabs'}>
                {
                    Object.keys(shopItems).map((tab, index) =>
                        <Link key={index} className={`tab ${tab}Tab ${(selectedTab === tab) ? 'selected' : ''}`} to={`/shop/${tab}`}>
                            <span>{t(`shop.${tab}.text`)}</span>
                        </Link>
                    )
                }
            </div>
            <div className={`content`}>
                { selectedTab === "coins" && <Coins/> }
                { selectedTab === "items" && <Items/> }
                { selectedTab === "sapphires" && <Sapphires/> }
            </div>
        </div>
    );
};

export default Shop ;
